import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #313131;
    --navy: #313131;
    --light-navy: #414141;
    --lightest-navy: #525252;
    --navy-shadow: rgba(28, 30, 35, 0.7);
  
    --dark-slate: #7C7575;
    --slate: #B8B0B0;
    --light-slate: #DFD3D3;
    --lightest-slate: #FBF0F0 ;
  
    --white: #f5f5f5;
    --green: #F9E795;
    --green-tint: rgba(93, 191, 99, 0.1);
    --pink: #F96167;
    --blue: #0099FF;
    --dark-teal: #495E57;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 25px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
